var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCategoriasHomeoffice(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#C1ABE6",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_760_5429)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9369 5.90476C13.4203 5.44572 12.7246 5.18848 12 5.18848C11.2754 5.18848 10.5797 5.44572 10.0631 5.90476L9.14286 5.05813C9.90446 4.38009 10.9308 4 12 4C13.0692 4 14.0955 4.38009 14.8571 5.05813L13.9369 5.90476Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6165 7.42857L10.4762 6.44184C10.8817 6.09778 11.4293 5.90476 12 5.90476C12.5707 5.90476 13.1183 6.09778 13.5238 6.44184L12.3905 7.42857C12.2857 7.34406 12.1473 7.297 12.0035 7.297C11.8596 7.297 11.7212 7.34406 11.6165 7.42857Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.38095 15.7617L11.4273 8.437C11.7436 8.10821 12.2564 8.10821 12.5727 8.437L19.619 15.7617L18.4736 16.9523L17.3333 15.7669V20H6.6666V15.767L5.52636 16.9523L4.38095 15.7617ZM12 10.223L15.9502 14.3292V18.7223H8.04963V14.3294L12 10.223Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_760_5429"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoriasHomeoffice);
export default __webpack_public_path__ + "static/media/categorias-homeoffice.882fc38d3833a85b97a04e2cc6ae38dc.svg";
export { ForwardRef as ReactComponent };